const _initialState = {
  id: null,
  userMode: -1,
  username: null,
  avatar: null,
  email: null,
  isLoggedIn: false,
  isAdmin: false,
  isCustomer: false,
  layers: [],
  // colors: {
  //   primary: '#33856b',
  //   dark: '#20755d',
  //   accent: '#FF4081',
  // },
  isMock: false,
  cityId: 0,
  seeChat: false,
}

export const initialState = _initialState

export const set = (state, payload) => payload

export const reset = () => _initialState

export const update = (state, payload) => ({
  ...state,
  ...payload,
})
